import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Indicator, IndicatorProps } from './indicator.component';

export type ValidationIndicatorProps = IndicatorProps & {
  touched: boolean;
  isValid: boolean;
};

const useStyles = makeStyles<ValidationIndicatorProps>()({
  root: {
    display: 'flex',
    alignItems: 'center',
  }
});

const chooseColor = (touched: boolean, isValid: boolean) => {
  if (!touched && !isValid) {
    return 'grey';
  }

  if (isValid) {
    return 'secondary';
  }

  return 'error';
};

export const ValidationIndicator: React.FC<ValidationIndicatorProps> = props => {
  const { classes, cx } = useStyles(props, { props });
  const size = props.size ?? 'lg';

  return (
    <Indicator
      color={chooseColor(props.touched, props.isValid)}
      size={size}
      className={cx(classes.root, props.className)}
    >
      {props.children}
    </Indicator>
  );
};
